import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getRegionList(params) {
  return request({
    url: URL.mdm.basicData.region,
    method: 'get',
    params
  })
}

export function getAllRegionList() {
  return request({
    url: URL.mdm.basicData.regions,
    method: 'get'
  })
}

export function saveRegion(data) {
  return request({
    url: URL.mdm.basicData.region,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delRegion(uuid) {
  return request({
    url: URL.mdm.basicData.region + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
